export enum LinkStatus {
  Checked = 'Checked',
  Broken = 'Broken',
  Inactive = 'Inactive',
  Scam = 'Scam',
  Pending = 'Pending'
}

export enum ProgramStatus {
  broken = 'broken',
  checked = 'checked',
  pending = 'pending',
  complete = 'complete'
}